import { render, staticRenderFns } from "./crewNewsMore.vue?vue&type=template&id=2c3e9da1&scoped=true"
import script from "./crewNewsMore.vue?vue&type=script&lang=js"
export * from "./crewNewsMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3e9da1",
  null
  
)

export default component.exports